import { useState, useEffect, useCallback } from 'react';

/**
 * 범용 데이터 패칭 훅.
 * fetcher: () => Promise<AxiosResponse>
 * deps: useEffect dependency 배열
 */
function useMonitoringData(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    setIsLoading(true);
    setError(null);
    fetcher()
      .then((res) => setData(res.data))
      .catch((err) => setError(err))
      .finally(() => setIsLoading(false));
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, isLoading, error, refresh };
}

export default useMonitoringData;
